<template>
  <div class="wrapper">
    <div class="title">
      {{ `${$t('重置登录密码')}（1/3)` }}
    </div>
    <div class="id-card">
      <FormInput
        ref="resetInputIDcard"
        class="input"
        v-model="formData.idCard"
        :placeholder="$t('请输入身份证号')"
        :input-disabled="false"
        :max-length="18"
        :reg-exp="/[^0-9xX]/g"/>
    </div>
    <div class="graphics-code">
      <FormInput
        ref="resetInputGraphicsCode"
        class="input"
        v-model="formData.graphicsCode"
        :max-length="4"
        :reg-exp="/[^0-9a-zA-Z]/g"
        :placeholder="$t('请输入图形验证码')"
        :input-disabled="false"/>
      <div
        class="btn graphics-code-btn"
        @click="handleGetGraphicsCode">
        <img :src="captchaImg" alt="graphics">
      </div>
    </div>
    <div class="verify-code">
      <FormInput
        ref="resetInputVerifyCode"
        class="input"
        v-model="formData.verifyCode"
        :placeholder="$t('请输入验证码')"
        :input-disabled="false"
        :reg-exp="/[^0-9]/g"/>
      <CountDown
        ref="countDown"
        class="btn verify-code-btn"
        text="获取验证码"
        color="#4A6AFF"
        inactive-style="border: 1px solid #D9DBE8; color: #BBC0D8;"
        :active="countDownActive"
        :loading="countDownLoading"
        :total-count="60"
        @click="handleCountDownClick"/>
    </div>
    <div class="login-tip">
      {{ $t('验证码将发送到您注册时提交的手机及邮箱中，请注意查收') }}
    </div>
    <div
      class="login-tip"
      style="margin-top: 6px;"
      v-if="showVoice">
      {{ $t('收不到短信？') }}
      <span
        class="login-tip-voice"
        :class="voiceLoading ? 'disabled' : ''"
        @click="handleVoiceClick">
        {{ $t('获取语音验证码') }}
      </span>
      <span
        style="margin-left: 5px;"
        v-if="voiceCount">
        {{voiceCount}}s{{$t('后获取')}}
      </span>
    </div>
    <el-button
      class="confirm-btn"
      type="primary"
      :disabled="confirmBtnDisabled"
      @click="handleConfirm">
      {{ $t('确定') }}
    </el-button>
    <BackButton
      @click="SET_LOGIN_STATE('page-form')"/>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import loginApi from '@/api/login'
import { getPromptOfVerifyCode } from '@/utils/lang'
export default {
  components: {
  },
  data () {
    return {
      // 图形验证码id
      captchaId: '',
      // 图形验证码bas64地址
      captchaImg: '',
      formData: {
        idCard: '',
        graphicsCode: '',
        verifyCode: ''
      },
      countDownLoading: false,
      // 获取语音验证码 根据后端接口响应来判断
      showVoice: true,
      // 已获取语音验证码
      voiceLoading: false,
      // 语音验证码倒计时
      voiceCount: 0,
      // 语音验证码定时器
      voiceTimer: null
    }
  },
  computed: {
    ...mapState('login', ['userInfo']),
    countDownActive () {
      const { idCard, graphicsCode } = this.formData
      const { countDownLoading } = this
      if (countDownLoading) {
        return false
      }
      // 身份证号 图形验证码
      if (!idCard || !graphicsCode || graphicsCode.length < 4) {
        return false
      }
      return true
    },
    confirmBtnDisabled () {
      const { idCard, graphicsCode, verifyCode } = this.formData
      if (!idCard || !graphicsCode || graphicsCode.length < 4 || verifyCode.length < 4) {
        return true
      }
      return false
    }
  },
  created () {
    this.getGraphicsCode()
  },
  beforeDestroy () {
    this.voiceTimer && clearInterval(this.voiceTimer)
  },
  methods: {
    ...mapMutations('login', ['SET_LOGIN_STATE', 'SET_RESET_STATE', 'SET_FACE_TOKEN']),
    // 获取图形验证码
    getGraphicsCode () {
      const { captchaId } = this
      return loginApi.getGraphicsCode({
        type: 'RESET_PWD',
        captchaId
      }).then(res => {
        if (res) {
          const { captchaId, captchaBase64 } = res
          this.captchaId = captchaId
          this.captchaImg = `data:image/jpg;base64,${captchaBase64}`
        }
      }).catch(err => {
        console.error(err)
      })
    },
    handleGetGraphicsCode () {
      this.getGraphicsCode()
      this.$refs.resetInputGraphicsCode.$refs.input.focus()
    },
    // 获取短信验证码
    handleCountDownClick () {
      const { customerId: cstId, userId } = this.userInfo
      const { graphicsCode: captcha } = this.formData
      const { captchaId } = this
      this.countDownLoading = true
      loginApi.getSmsCode({
        cstId,
        userId,
        captcha,
        captchaId,
        type: 'RESET_PWD'
      }).then(res => {
        this.countDownLoading = false
        if (res) {
          this.$refs.countDown.startCountDown()
          const { email, mobile, showVoice } = res
          const message = getPromptOfVerifyCode(mobile, email)
          this.$talert(message, '系统提示', {
            dangerouslyUseHTMLString: true
          }).then(() => {
            this.$refs.resetInputVerifyCode.$refs.input.focus()
          })
          this.showVoice = showVoice
        }
      }).catch(() => {
        // 刷新图形验证码
        this.getGraphicsCode()
        this.countDownLoading = false
      })
    },
    // 获取语音验证码
    handleVoiceClick () {
      const { customerId: cstId, userId } = this.userInfo
      const { graphicsCode: captcha } = this.formData
      const { captchaId, voiceCount } = this
      // 防止多次点击
      if (voiceCount) {
        return
      }
      if (!cstId) {
        this.$warn('请输入客户号')
        return
      }
      if (!userId) {
        this.$warn('请输入用户号')
        return
      }
      if (!captcha) {
        this.$warn('请输入图形验证码')
        return
      }
      this.voiceLoading = true
      loginApi.getVoiceCode({
        cstId,
        userId,
        captcha,
        captchaId,
        type: 'RESET_PWD'
      }).then(res => {
        this.voiceLoading = false
        if (res) {
          const message = 'CBiBank将给您拨打电话，通过语音播报验证码，请接听来电。'
          this.$talert(message, '系统提示').then(() => {
            this.$refs.resetInputVerifyCode.$refs.input.focus()
          })
          this.voiceCount = 300
          // 创建定时器
          this.voiceTimer = setInterval(() => {
            if (this.voiceCount <= 0) {
              clearInterval(this.voiceTimer)
              this.voiceTimer = null
              this.voiceCount = 0
              return
            }
            this.voiceCount -= 1
          }, 1000)
        }
      }).catch(() => {
        // 刷新图形验证码
        this.getGraphicsCode()
        this.voiceLoading = false
      })
    },
    handleConfirm () {
      const { customerId: cstId, userId } = this.userInfo
      const { idCard: idCardNo, graphicsCode: captcha, verifyCode: code } = this.formData
      const { captchaId } = this
      if (!/^[0-9]{17}[0-9xX]{1}$/.test(idCardNo)) {
        this.$warn('请输入正确的身份证号')
        return
      }
      loginApi.getTokenOfFaceId({
        cstId,
        userId,
        idCardNo,
        captchaId,
        captcha,
        code
      }).then(res => {
        if (res) {
          const { faceToken } = res
          this.SET_FACE_TOKEN(faceToken)
          // 跳转第二步
          this.SET_RESET_STATE('stepTwo')
        }
      }).catch(err => {
        console.error(err)
      })
    }
  }
}
</script>

<style scoped lang="less">
.wrapper {
  padding: 62px 34px 0;
  .title {
    text-align: left;
    font-size: 20px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #131523;
    line-height: 20px;
  }
  .input {
    width: 200px;
    height: 46px;
    line-height: 46px;
    text-align: left;
  }
  .btn {
    width: 110px;
    height: 46px;
    line-height: 46px;
    text-align: center;
    border-radius: 2px;
    border: 1px solid #D9DBE8;
    cursor: pointer;
  }
  .id-card {
    width: 100%;
    margin: 35px 0 15px;
    > .input {
      width: 100%;
    }
  }
  .graphics-code {
    display: flex;
    justify-content: space-between;
    .graphics-code-btn {
      > img {
        display: block;
        width: 100%;
        height: 100%;
      }
    }
  }
  .verify-code {
    display: flex;
    justify-content: space-between;
    margin: 15px 0 10px;
    .verify-code-btn {
      font-size: 14px;
      font-weight: 400;
      color: #BBC0D8;
    }
  }
  .login-tip {
    font-size: 12px;
    font-weight: 400;
    color: #A1A7C4;
    line-height: 14px;
    text-align: left;
    user-select: none;
    .login-tip-voice {
      color: #4A6AFF;
      cursor: pointer;
    }
    .disabled {
      cursor: not-allowed;
    }
  }
  .confirm-btn {
    margin-top: 50px;
    width: 320px;
    height: 46px;
  }
}
</style>
